import Configuracion from '@/model/Configuracion';
import { configuracionService } from '@/services';
import { LoadingStatus } from '@pjn/core/ui/loading';
import { Store } from '@pjn/vue-core/store';
import { Mutation } from '@pjn/vue-core/store/annotations';
import Vue from 'vue';

import { uiStore } from '.';

/**
 * Store que consulta y actualiza configuraciones
 */
@Store
export default class ConfiguracionStore extends Vue {
  configuracion: Configuracion = {
    id: 1,
    mail: '',
      vigenciaAnios: 3,
      proximas: {
        dias: (undefined as unknown) as number,
        frecuencia: [],
      },
      vencidas: {
        frecuencia: [],
      },
    }

  /** Estado de carga de (para mostrar loader). */
  status: LoadingStatus = {};

  /**
   * Realiza la consulta del las configuraciones
   */
 


  async load() {
    this.beginRequest();
    try {
      const configuracion = await configuracionService.get()
      this.loadSuccess(configuracion);
      return { ...configuracion };
    } catch (e) {
      
      uiStore.notification.error(e)
      this.loadFail();
      return null;
    }
  }

    async reload() {
    if (this.configuracion?.id) {
      if (
        await this.load(
        )
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * Guarda la configuracion
   */
  async save(unConfiguracion = this.configuracion) {
    try {
      const configuracion: Configuracion | null = unConfiguracion ?  await configuracionService.save(unConfiguracion) : null
      configuracion ? this.loadSuccess(configuracion) : this.loadFail()
      uiStore.notification.info("Configuraciones guardadas con éxito")
      return configuracion;
    } catch (e) {
      uiStore.notification.error(e)
      this.fail();
      return null;
    }
  }

 
   
  @Mutation
  private beginRequest() {
    this.status = { loading: true };
  }

  @Mutation
  private loadSuccess(configuracion: Configuracion) {
    this.status = {};
    this.configuracion = configuracion;
  }

  @Mutation
  updateSuccess(configuracion: Configuracion) {
    this.configuracion = configuracion;

    return true;
  }
 

  @Mutation
  private loadFail() {
    this.status = { error: true };
    this.configuracion = null as unknown as Configuracion;
  }

  @Mutation
  private fail() {
    this.status = { error: true };
  }
}
